/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthOtpResponse as ModelsAuthenticationAuthOtpResponse } from '../models/Models/Authentication/auth-otp-response';
import { CustomerAccountsResponse as ModelsCustomerCustomerAccountsResponse } from '../models/Models/Customer/customer-accounts-response';
import { CustomerDetailsResponse as ModelsCustomerCustomerDetailsResponse } from '../models/Models/Customer/customer-details-response';
import { CustomerEnquiryResponse as ModelsCustomerCustomerEnquiryResponse } from '../models/Models/Customer/customer-enquiry-response';
import { CustomerOffersResponse as ModelsCustomerCustomerOffersResponse } from '../models/Models/Customer/customer-offers-response';
import { CustomerOnlinePaymentResponse as ModelsCustomerCustomerOnlinePaymentResponse } from '../models/Models/Customer/customer-online-payment-response';
import { CustomerOnlinePaymentsResponse as ModelsCustomerCustomerOnlinePaymentsResponse } from '../models/Models/Customer/customer-online-payments-response';
import { CustomerOnlinePaymentTypesResponse as ModelsCustomerCustomerOnlinePaymentTypesResponse } from '../models/Models/Customer/customer-online-payment-types-response';
import { CustomerScheduledPaymentsResponse as ModelsCustomerCustomerScheduledPaymentsResponse } from '../models/Models/Customer/customer-scheduled-payments-response';
import { CustomerOnlinePaymentStatusEnum as ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum } from '../models/Models/Customer/Enums/customer-online-payment-status-enum';
import { v4CustomersMeAccountsAccountNumberGet$Json } from '../fn/customers/v-4-customers-me-accounts-account-number-get-json';
import { V4CustomersMeAccountsAccountNumberGet$Json$Params } from '../fn/customers/v-4-customers-me-accounts-account-number-get-json';
import { v4CustomersMeAccountsAccountNumberGet$Plain } from '../fn/customers/v-4-customers-me-accounts-account-number-get-plain';
import { V4CustomersMeAccountsAccountNumberGet$Plain$Params } from '../fn/customers/v-4-customers-me-accounts-account-number-get-plain';
import { v4CustomersMeAccountsAccountNumberGet$Xml } from '../fn/customers/v-4-customers-me-accounts-account-number-get-xml';
import { V4CustomersMeAccountsAccountNumberGet$Xml$Params } from '../fn/customers/v-4-customers-me-accounts-account-number-get-xml';
import { v4CustomersMeAccountsAccountNumberPaymentsGet$Json } from '../fn/customers/v-4-customers-me-accounts-account-number-payments-get-json';
import { V4CustomersMeAccountsAccountNumberPaymentsGet$Json$Params } from '../fn/customers/v-4-customers-me-accounts-account-number-payments-get-json';
import { v4CustomersMeAccountsAccountNumberPaymentsGet$Plain } from '../fn/customers/v-4-customers-me-accounts-account-number-payments-get-plain';
import { V4CustomersMeAccountsAccountNumberPaymentsGet$Plain$Params } from '../fn/customers/v-4-customers-me-accounts-account-number-payments-get-plain';
import { v4CustomersMeAccountsAccountNumberPaymentsGet$Xml } from '../fn/customers/v-4-customers-me-accounts-account-number-payments-get-xml';
import { V4CustomersMeAccountsAccountNumberPaymentsGet$Xml$Params } from '../fn/customers/v-4-customers-me-accounts-account-number-payments-get-xml';
import { v4CustomersMeDetailsGet } from '../fn/customers/v-4-customers-me-details-get';
import { V4CustomersMeDetailsGet$Params } from '../fn/customers/v-4-customers-me-details-get';
import { v4CustomersMeDetailsOtpGet$Json } from '../fn/customers/v-4-customers-me-details-otp-get-json';
import { V4CustomersMeDetailsOtpGet$Json$Params } from '../fn/customers/v-4-customers-me-details-otp-get-json';
import { v4CustomersMeDetailsOtpGet$Plain } from '../fn/customers/v-4-customers-me-details-otp-get-plain';
import { V4CustomersMeDetailsOtpGet$Plain$Params } from '../fn/customers/v-4-customers-me-details-otp-get-plain';
import { v4CustomersMeDetailsOtpGet$Xml } from '../fn/customers/v-4-customers-me-details-otp-get-xml';
import { V4CustomersMeDetailsOtpGet$Xml$Params } from '../fn/customers/v-4-customers-me-details-otp-get-xml';
import { v4CustomersMeDetailsPatch$Json$Json } from '../fn/customers/v-4-customers-me-details-patch-json-json';
import { V4CustomersMeDetailsPatch$Json$Json$Params } from '../fn/customers/v-4-customers-me-details-patch-json-json';
import { v4CustomersMeDetailsPatch$Json$Plain } from '../fn/customers/v-4-customers-me-details-patch-json-plain';
import { V4CustomersMeDetailsPatch$Json$Plain$Params } from '../fn/customers/v-4-customers-me-details-patch-json-plain';
import { v4CustomersMeDetailsPatch$Json$Xml } from '../fn/customers/v-4-customers-me-details-patch-json-xml';
import { V4CustomersMeDetailsPatch$Json$Xml$Params } from '../fn/customers/v-4-customers-me-details-patch-json-xml';
import { v4CustomersMeDetailsPatch$Xml$Json } from '../fn/customers/v-4-customers-me-details-patch-xml-json';
import { V4CustomersMeDetailsPatch$Xml$Json$Params } from '../fn/customers/v-4-customers-me-details-patch-xml-json';
import { v4CustomersMeDetailsPatch$Xml$Plain } from '../fn/customers/v-4-customers-me-details-patch-xml-plain';
import { V4CustomersMeDetailsPatch$Xml$Plain$Params } from '../fn/customers/v-4-customers-me-details-patch-xml-plain';
import { v4CustomersMeDetailsPatch$Xml$Xml } from '../fn/customers/v-4-customers-me-details-patch-xml-xml';
import { V4CustomersMeDetailsPatch$Xml$Xml$Params } from '../fn/customers/v-4-customers-me-details-patch-xml-xml';
import { v4CustomersMeDetailsPut$Json$Json } from '../fn/customers/v-4-customers-me-details-put-json-json';
import { V4CustomersMeDetailsPut$Json$Json$Params } from '../fn/customers/v-4-customers-me-details-put-json-json';
import { v4CustomersMeDetailsPut$Json$Plain } from '../fn/customers/v-4-customers-me-details-put-json-plain';
import { V4CustomersMeDetailsPut$Json$Plain$Params } from '../fn/customers/v-4-customers-me-details-put-json-plain';
import { v4CustomersMeDetailsPut$Json$Xml } from '../fn/customers/v-4-customers-me-details-put-json-xml';
import { V4CustomersMeDetailsPut$Json$Xml$Params } from '../fn/customers/v-4-customers-me-details-put-json-xml';
import { v4CustomersMeDetailsPut$Xml$Json } from '../fn/customers/v-4-customers-me-details-put-xml-json';
import { V4CustomersMeDetailsPut$Xml$Json$Params } from '../fn/customers/v-4-customers-me-details-put-xml-json';
import { v4CustomersMeDetailsPut$Xml$Plain } from '../fn/customers/v-4-customers-me-details-put-xml-plain';
import { V4CustomersMeDetailsPut$Xml$Plain$Params } from '../fn/customers/v-4-customers-me-details-put-xml-plain';
import { v4CustomersMeDetailsPut$Xml$Xml } from '../fn/customers/v-4-customers-me-details-put-xml-xml';
import { V4CustomersMeDetailsPut$Xml$Xml$Params } from '../fn/customers/v-4-customers-me-details-put-xml-xml';
import { v4CustomersMeEnquiryPost$Json$Json } from '../fn/customers/v-4-customers-me-enquiry-post-json-json';
import { V4CustomersMeEnquiryPost$Json$Json$Params } from '../fn/customers/v-4-customers-me-enquiry-post-json-json';
import { v4CustomersMeEnquiryPost$Json$Plain } from '../fn/customers/v-4-customers-me-enquiry-post-json-plain';
import { V4CustomersMeEnquiryPost$Json$Plain$Params } from '../fn/customers/v-4-customers-me-enquiry-post-json-plain';
import { v4CustomersMeEnquiryPost$Json$Xml } from '../fn/customers/v-4-customers-me-enquiry-post-json-xml';
import { V4CustomersMeEnquiryPost$Json$Xml$Params } from '../fn/customers/v-4-customers-me-enquiry-post-json-xml';
import { v4CustomersMeEnquiryPost$Xml$Json } from '../fn/customers/v-4-customers-me-enquiry-post-xml-json';
import { V4CustomersMeEnquiryPost$Xml$Json$Params } from '../fn/customers/v-4-customers-me-enquiry-post-xml-json';
import { v4CustomersMeEnquiryPost$Xml$Plain } from '../fn/customers/v-4-customers-me-enquiry-post-xml-plain';
import { V4CustomersMeEnquiryPost$Xml$Plain$Params } from '../fn/customers/v-4-customers-me-enquiry-post-xml-plain';
import { v4CustomersMeEnquiryPost$Xml$Xml } from '../fn/customers/v-4-customers-me-enquiry-post-xml-xml';
import { V4CustomersMeEnquiryPost$Xml$Xml$Params } from '../fn/customers/v-4-customers-me-enquiry-post-xml-xml';
import { v4CustomersMeNotificationsGet$Json } from '../fn/customers/v-4-customers-me-notifications-get-json';
import { V4CustomersMeNotificationsGet$Json$Params } from '../fn/customers/v-4-customers-me-notifications-get-json';
import { v4CustomersMeNotificationsGet$Plain } from '../fn/customers/v-4-customers-me-notifications-get-plain';
import { V4CustomersMeNotificationsGet$Plain$Params } from '../fn/customers/v-4-customers-me-notifications-get-plain';
import { v4CustomersMeNotificationsGet$Xml } from '../fn/customers/v-4-customers-me-notifications-get-xml';
import { V4CustomersMeNotificationsGet$Xml$Params } from '../fn/customers/v-4-customers-me-notifications-get-xml';
import { v4CustomersMeNotificationsNotificationIdDelete$Json } from '../fn/customers/v-4-customers-me-notifications-notification-id-delete-json';
import { V4CustomersMeNotificationsNotificationIdDelete$Json$Params } from '../fn/customers/v-4-customers-me-notifications-notification-id-delete-json';
import { v4CustomersMeNotificationsNotificationIdDelete$Plain } from '../fn/customers/v-4-customers-me-notifications-notification-id-delete-plain';
import { V4CustomersMeNotificationsNotificationIdDelete$Plain$Params } from '../fn/customers/v-4-customers-me-notifications-notification-id-delete-plain';
import { v4CustomersMeNotificationsNotificationIdDelete$Xml } from '../fn/customers/v-4-customers-me-notifications-notification-id-delete-xml';
import { V4CustomersMeNotificationsNotificationIdDelete$Xml$Params } from '../fn/customers/v-4-customers-me-notifications-notification-id-delete-xml';
import { v4CustomersMeNotificationsNotificationIdGet$Json } from '../fn/customers/v-4-customers-me-notifications-notification-id-get-json';
import { V4CustomersMeNotificationsNotificationIdGet$Json$Params } from '../fn/customers/v-4-customers-me-notifications-notification-id-get-json';
import { v4CustomersMeNotificationsNotificationIdGet$Plain } from '../fn/customers/v-4-customers-me-notifications-notification-id-get-plain';
import { V4CustomersMeNotificationsNotificationIdGet$Plain$Params } from '../fn/customers/v-4-customers-me-notifications-notification-id-get-plain';
import { v4CustomersMeNotificationsNotificationIdGet$Xml } from '../fn/customers/v-4-customers-me-notifications-notification-id-get-xml';
import { V4CustomersMeNotificationsNotificationIdGet$Xml$Params } from '../fn/customers/v-4-customers-me-notifications-notification-id-get-xml';
import { v4CustomersMeNotificationsNotificationIdReadStatusPatch$Json } from '../fn/customers/v-4-customers-me-notifications-notification-id-read-status-patch-json';
import { V4CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Params } from '../fn/customers/v-4-customers-me-notifications-notification-id-read-status-patch-json';
import { v4CustomersMeNotificationsNotificationIdReadStatusPatch$Plain } from '../fn/customers/v-4-customers-me-notifications-notification-id-read-status-patch-plain';
import { V4CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Params } from '../fn/customers/v-4-customers-me-notifications-notification-id-read-status-patch-plain';
import { v4CustomersMeNotificationsNotificationIdReadStatusPatch$Xml } from '../fn/customers/v-4-customers-me-notifications-notification-id-read-status-patch-xml';
import { V4CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Params } from '../fn/customers/v-4-customers-me-notifications-notification-id-read-status-patch-xml';
import { v4CustomersMeNotificationsPatch$Json } from '../fn/customers/v-4-customers-me-notifications-patch-json';
import { V4CustomersMeNotificationsPatch$Json$Params } from '../fn/customers/v-4-customers-me-notifications-patch-json';
import { v4CustomersMeNotificationsPatch$Plain } from '../fn/customers/v-4-customers-me-notifications-patch-plain';
import { V4CustomersMeNotificationsPatch$Plain$Params } from '../fn/customers/v-4-customers-me-notifications-patch-plain';
import { v4CustomersMeNotificationsPatch$Xml } from '../fn/customers/v-4-customers-me-notifications-patch-xml';
import { V4CustomersMeNotificationsPatch$Xml$Params } from '../fn/customers/v-4-customers-me-notifications-patch-xml';
import { v4CustomersMeNotificationsUnreadGet$Json } from '../fn/customers/v-4-customers-me-notifications-unread-get-json';
import { V4CustomersMeNotificationsUnreadGet$Json$Params } from '../fn/customers/v-4-customers-me-notifications-unread-get-json';
import { v4CustomersMeNotificationsUnreadGet$Plain } from '../fn/customers/v-4-customers-me-notifications-unread-get-plain';
import { V4CustomersMeNotificationsUnreadGet$Plain$Params } from '../fn/customers/v-4-customers-me-notifications-unread-get-plain';
import { v4CustomersMeNotificationsUnreadGet$Xml } from '../fn/customers/v-4-customers-me-notifications-unread-get-xml';
import { V4CustomersMeNotificationsUnreadGet$Xml$Params } from '../fn/customers/v-4-customers-me-notifications-unread-get-xml';
import { v4CustomersMeOffersGet$Json } from '../fn/customers/v-4-customers-me-offers-get-json';
import { V4CustomersMeOffersGet$Json$Params } from '../fn/customers/v-4-customers-me-offers-get-json';
import { v4CustomersMeOffersGet$Plain } from '../fn/customers/v-4-customers-me-offers-get-plain';
import { V4CustomersMeOffersGet$Plain$Params } from '../fn/customers/v-4-customers-me-offers-get-plain';
import { v4CustomersMeOffersGet$Xml } from '../fn/customers/v-4-customers-me-offers-get-xml';
import { V4CustomersMeOffersGet$Xml$Params } from '../fn/customers/v-4-customers-me-offers-get-xml';
import { v4CustomersMeOffersOfferIdPatch$Json } from '../fn/customers/v-4-customers-me-offers-offer-id-patch-json';
import { V4CustomersMeOffersOfferIdPatch$Json$Params } from '../fn/customers/v-4-customers-me-offers-offer-id-patch-json';
import { v4CustomersMeOffersOfferIdPatch$Plain } from '../fn/customers/v-4-customers-me-offers-offer-id-patch-plain';
import { V4CustomersMeOffersOfferIdPatch$Plain$Params } from '../fn/customers/v-4-customers-me-offers-offer-id-patch-plain';
import { v4CustomersMeOffersOfferIdPatch$Xml } from '../fn/customers/v-4-customers-me-offers-offer-id-patch-xml';
import { V4CustomersMeOffersOfferIdPatch$Xml$Params } from '../fn/customers/v-4-customers-me-offers-offer-id-patch-xml';
import { v4CustomersMeOnlinePaymentsGet$Json } from '../fn/customers/v-4-customers-me-online-payments-get-json';
import { V4CustomersMeOnlinePaymentsGet$Json$Params } from '../fn/customers/v-4-customers-me-online-payments-get-json';
import { v4CustomersMeOnlinePaymentsGet$Plain } from '../fn/customers/v-4-customers-me-online-payments-get-plain';
import { V4CustomersMeOnlinePaymentsGet$Plain$Params } from '../fn/customers/v-4-customers-me-online-payments-get-plain';
import { v4CustomersMeOnlinePaymentsGet$Xml } from '../fn/customers/v-4-customers-me-online-payments-get-xml';
import { V4CustomersMeOnlinePaymentsGet$Xml$Params } from '../fn/customers/v-4-customers-me-online-payments-get-xml';
import { v4CustomersMeOnlinePaymentsIdGet$Json } from '../fn/customers/v-4-customers-me-online-payments-id-get-json';
import { V4CustomersMeOnlinePaymentsIdGet$Json$Params } from '../fn/customers/v-4-customers-me-online-payments-id-get-json';
import { v4CustomersMeOnlinePaymentsIdGet$Plain } from '../fn/customers/v-4-customers-me-online-payments-id-get-plain';
import { V4CustomersMeOnlinePaymentsIdGet$Plain$Params } from '../fn/customers/v-4-customers-me-online-payments-id-get-plain';
import { v4CustomersMeOnlinePaymentsIdGet$Xml } from '../fn/customers/v-4-customers-me-online-payments-id-get-xml';
import { V4CustomersMeOnlinePaymentsIdGet$Xml$Params } from '../fn/customers/v-4-customers-me-online-payments-id-get-xml';
import { v4CustomersMeOnlinePaymentsIdStatusGet$Json } from '../fn/customers/v-4-customers-me-online-payments-id-status-get-json';
import { V4CustomersMeOnlinePaymentsIdStatusGet$Json$Params } from '../fn/customers/v-4-customers-me-online-payments-id-status-get-json';
import { v4CustomersMeOnlinePaymentsIdStatusGet$Plain } from '../fn/customers/v-4-customers-me-online-payments-id-status-get-plain';
import { V4CustomersMeOnlinePaymentsIdStatusGet$Plain$Params } from '../fn/customers/v-4-customers-me-online-payments-id-status-get-plain';
import { v4CustomersMeOnlinePaymentsIdStatusGet$Xml } from '../fn/customers/v-4-customers-me-online-payments-id-status-get-xml';
import { V4CustomersMeOnlinePaymentsIdStatusGet$Xml$Params } from '../fn/customers/v-4-customers-me-online-payments-id-status-get-xml';
import { v4CustomersMeOnlinePaymentsPost$Json$Json } from '../fn/customers/v-4-customers-me-online-payments-post-json-json';
import { V4CustomersMeOnlinePaymentsPost$Json$Json$Params } from '../fn/customers/v-4-customers-me-online-payments-post-json-json';
import { v4CustomersMeOnlinePaymentsPost$Json$Plain } from '../fn/customers/v-4-customers-me-online-payments-post-json-plain';
import { V4CustomersMeOnlinePaymentsPost$Json$Plain$Params } from '../fn/customers/v-4-customers-me-online-payments-post-json-plain';
import { v4CustomersMeOnlinePaymentsPost$Json$Xml } from '../fn/customers/v-4-customers-me-online-payments-post-json-xml';
import { V4CustomersMeOnlinePaymentsPost$Json$Xml$Params } from '../fn/customers/v-4-customers-me-online-payments-post-json-xml';
import { v4CustomersMeOnlinePaymentsPost$Xml$Json } from '../fn/customers/v-4-customers-me-online-payments-post-xml-json';
import { V4CustomersMeOnlinePaymentsPost$Xml$Json$Params } from '../fn/customers/v-4-customers-me-online-payments-post-xml-json';
import { v4CustomersMeOnlinePaymentsPost$Xml$Plain } from '../fn/customers/v-4-customers-me-online-payments-post-xml-plain';
import { V4CustomersMeOnlinePaymentsPost$Xml$Plain$Params } from '../fn/customers/v-4-customers-me-online-payments-post-xml-plain';
import { v4CustomersMeOnlinePaymentsPost$Xml$Xml } from '../fn/customers/v-4-customers-me-online-payments-post-xml-xml';
import { V4CustomersMeOnlinePaymentsPost$Xml$Xml$Params } from '../fn/customers/v-4-customers-me-online-payments-post-xml-xml';
import { v4CustomersMeOnlinePaymentTypesGet$Json } from '../fn/customers/v-4-customers-me-online-payment-types-get-json';
import { V4CustomersMeOnlinePaymentTypesGet$Json$Params } from '../fn/customers/v-4-customers-me-online-payment-types-get-json';
import { v4CustomersMeOnlinePaymentTypesGet$Plain } from '../fn/customers/v-4-customers-me-online-payment-types-get-plain';
import { V4CustomersMeOnlinePaymentTypesGet$Plain$Params } from '../fn/customers/v-4-customers-me-online-payment-types-get-plain';
import { v4CustomersMeOnlinePaymentTypesGet$Xml } from '../fn/customers/v-4-customers-me-online-payment-types-get-xml';
import { V4CustomersMeOnlinePaymentTypesGet$Xml$Params } from '../fn/customers/v-4-customers-me-online-payment-types-get-xml';
import { v4CustomersMePaymentsGet$Json } from '../fn/customers/v-4-customers-me-payments-get-json';
import { V4CustomersMePaymentsGet$Json$Params } from '../fn/customers/v-4-customers-me-payments-get-json';
import { v4CustomersMePaymentsGet$Plain } from '../fn/customers/v-4-customers-me-payments-get-plain';
import { V4CustomersMePaymentsGet$Plain$Params } from '../fn/customers/v-4-customers-me-payments-get-plain';
import { v4CustomersMePaymentsGet$Xml } from '../fn/customers/v-4-customers-me-payments-get-xml';
import { V4CustomersMePaymentsGet$Xml$Params } from '../fn/customers/v-4-customers-me-payments-get-xml';
import { v4CustomersMePingGet } from '../fn/customers/v-4-customers-me-ping-get';
import { V4CustomersMePingGet$Params } from '../fn/customers/v-4-customers-me-ping-get';

@Injectable({ providedIn: 'root' })
export class CustomersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4CustomersMePingGet()` */
  static readonly V4CustomersMePingGetPath = '/v4/customers/me/ping';

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMePingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMePingGet$Response(params?: V4CustomersMePingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v4CustomersMePingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMePingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMePingGet(params?: V4CustomersMePingGet$Params, context?: HttpContext): Observable<void> {
    return this.v4CustomersMePingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeDetailsGet()` */
  static readonly V4CustomersMeDetailsGetPath = '/v4/customers/me/details';

  /**
   * Gets the details belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeDetailsGet$Response(params?: V4CustomersMeDetailsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v4CustomersMeDetailsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the details belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeDetailsGet(params?: V4CustomersMeDetailsGet$Params, context?: HttpContext): Observable<void> {
    return this.v4CustomersMeDetailsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeDetailsPut()` */
  static readonly V4CustomersMeDetailsPutPath = '/v4/customers/me/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPut$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPut$Json$Plain$Response(params?: V4CustomersMeDetailsPut$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPut$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPut$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPut$Json$Plain(params?: V4CustomersMeDetailsPut$Json$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPut$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPut$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPut$Json$Json$Response(params?: V4CustomersMeDetailsPut$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPut$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPut$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPut$Json$Json(params?: V4CustomersMeDetailsPut$Json$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPut$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPut$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPut$Json$Xml$Response(params?: V4CustomersMeDetailsPut$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPut$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPut$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPut$Json$Xml(params?: V4CustomersMeDetailsPut$Json$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPut$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPut$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPut$Xml$Plain$Response(params?: V4CustomersMeDetailsPut$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPut$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPut$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPut$Xml$Plain(params?: V4CustomersMeDetailsPut$Xml$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPut$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPut$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPut$Xml$Json$Response(params?: V4CustomersMeDetailsPut$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPut$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPut$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPut$Xml$Json(params?: V4CustomersMeDetailsPut$Xml$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPut$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPut$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPut$Xml$Xml$Response(params?: V4CustomersMeDetailsPut$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPut$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPut$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPut$Xml$Xml(params?: V4CustomersMeDetailsPut$Xml$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPut$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeDetailsPatch()` */
  static readonly V4CustomersMeDetailsPatchPath = '/v4/customers/me/details';

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPatch$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPatch$Json$Plain$Response(params?: V4CustomersMeDetailsPatch$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPatch$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPatch$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPatch$Json$Plain(params?: V4CustomersMeDetailsPatch$Json$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPatch$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPatch$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPatch$Json$Json$Response(params?: V4CustomersMeDetailsPatch$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPatch$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPatch$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPatch$Json$Json(params?: V4CustomersMeDetailsPatch$Json$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPatch$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPatch$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPatch$Json$Xml$Response(params?: V4CustomersMeDetailsPatch$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPatch$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPatch$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeDetailsPatch$Json$Xml(params?: V4CustomersMeDetailsPatch$Json$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPatch$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPatch$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPatch$Xml$Plain$Response(params?: V4CustomersMeDetailsPatch$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPatch$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPatch$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPatch$Xml$Plain(params?: V4CustomersMeDetailsPatch$Xml$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPatch$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPatch$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPatch$Xml$Json$Response(params?: V4CustomersMeDetailsPatch$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPatch$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPatch$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPatch$Xml$Json(params?: V4CustomersMeDetailsPatch$Xml$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPatch$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsPatch$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPatch$Xml$Xml$Response(params?: V4CustomersMeDetailsPatch$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v4CustomersMeDetailsPatch$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsPatch$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeDetailsPatch$Xml$Xml(params?: V4CustomersMeDetailsPatch$Xml$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v4CustomersMeDetailsPatch$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeDetailsOtpGet()` */
  static readonly V4CustomersMeDetailsOtpGetPath = '/v4/customers/me/details-otp';

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsOtpGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeDetailsOtpGet$Plain$Response(params?: V4CustomersMeDetailsOtpGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>> {
    return v4CustomersMeDetailsOtpGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsOtpGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeDetailsOtpGet$Plain(params?: V4CustomersMeDetailsOtpGet$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthOtpResponse> {
    return this.v4CustomersMeDetailsOtpGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>): ModelsAuthenticationAuthOtpResponse => r.body)
    );
  }

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsOtpGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeDetailsOtpGet$Json$Response(params?: V4CustomersMeDetailsOtpGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>> {
    return v4CustomersMeDetailsOtpGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsOtpGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeDetailsOtpGet$Json(params?: V4CustomersMeDetailsOtpGet$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthOtpResponse> {
    return this.v4CustomersMeDetailsOtpGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>): ModelsAuthenticationAuthOtpResponse => r.body)
    );
  }

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeDetailsOtpGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeDetailsOtpGet$Xml$Response(params?: V4CustomersMeDetailsOtpGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>> {
    return v4CustomersMeDetailsOtpGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeDetailsOtpGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeDetailsOtpGet$Xml(params?: V4CustomersMeDetailsOtpGet$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthOtpResponse> {
    return this.v4CustomersMeDetailsOtpGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>): ModelsAuthenticationAuthOtpResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeAccountsAccountNumberGet()` */
  static readonly V4CustomersMeAccountsAccountNumberGetPath = '/v4/customers/me/accounts/{accountNumber}';

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeAccountsAccountNumberGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberGet$Plain$Response(params: V4CustomersMeAccountsAccountNumberGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>> {
    return v4CustomersMeAccountsAccountNumberGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeAccountsAccountNumberGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberGet$Plain(params: V4CustomersMeAccountsAccountNumberGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerAccountsResponse> {
    return this.v4CustomersMeAccountsAccountNumberGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>): ModelsCustomerCustomerAccountsResponse => r.body)
    );
  }

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeAccountsAccountNumberGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberGet$Json$Response(params: V4CustomersMeAccountsAccountNumberGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>> {
    return v4CustomersMeAccountsAccountNumberGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeAccountsAccountNumberGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberGet$Json(params: V4CustomersMeAccountsAccountNumberGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerAccountsResponse> {
    return this.v4CustomersMeAccountsAccountNumberGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>): ModelsCustomerCustomerAccountsResponse => r.body)
    );
  }

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeAccountsAccountNumberGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberGet$Xml$Response(params: V4CustomersMeAccountsAccountNumberGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>> {
    return v4CustomersMeAccountsAccountNumberGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeAccountsAccountNumberGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberGet$Xml(params: V4CustomersMeAccountsAccountNumberGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerAccountsResponse> {
    return this.v4CustomersMeAccountsAccountNumberGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>): ModelsCustomerCustomerAccountsResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMePaymentsGet()` */
  static readonly V4CustomersMePaymentsGetPath = '/v4/customers/me/payments';

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMePaymentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMePaymentsGet$Plain$Response(params?: V4CustomersMePaymentsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v4CustomersMePaymentsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMePaymentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMePaymentsGet$Plain(params?: V4CustomersMePaymentsGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v4CustomersMePaymentsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMePaymentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMePaymentsGet$Json$Response(params?: V4CustomersMePaymentsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v4CustomersMePaymentsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMePaymentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMePaymentsGet$Json(params?: V4CustomersMePaymentsGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v4CustomersMePaymentsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMePaymentsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMePaymentsGet$Xml$Response(params?: V4CustomersMePaymentsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v4CustomersMePaymentsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMePaymentsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMePaymentsGet$Xml(params?: V4CustomersMePaymentsGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v4CustomersMePaymentsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeAccountsAccountNumberPaymentsGet()` */
  static readonly V4CustomersMeAccountsAccountNumberPaymentsGetPath = '/v4/customers/me/accounts/{accountNumber}/payments';

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeAccountsAccountNumberPaymentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberPaymentsGet$Plain$Response(params: V4CustomersMeAccountsAccountNumberPaymentsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v4CustomersMeAccountsAccountNumberPaymentsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeAccountsAccountNumberPaymentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberPaymentsGet$Plain(params: V4CustomersMeAccountsAccountNumberPaymentsGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v4CustomersMeAccountsAccountNumberPaymentsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeAccountsAccountNumberPaymentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberPaymentsGet$Json$Response(params: V4CustomersMeAccountsAccountNumberPaymentsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v4CustomersMeAccountsAccountNumberPaymentsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeAccountsAccountNumberPaymentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberPaymentsGet$Json(params: V4CustomersMeAccountsAccountNumberPaymentsGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v4CustomersMeAccountsAccountNumberPaymentsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeAccountsAccountNumberPaymentsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberPaymentsGet$Xml$Response(params: V4CustomersMeAccountsAccountNumberPaymentsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v4CustomersMeAccountsAccountNumberPaymentsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeAccountsAccountNumberPaymentsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeAccountsAccountNumberPaymentsGet$Xml(params: V4CustomersMeAccountsAccountNumberPaymentsGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v4CustomersMeAccountsAccountNumberPaymentsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeOffersGet()` */
  static readonly V4CustomersMeOffersGetPath = '/v4/customers/me/offers';

  /**
   * Gets the offers applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOffersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersGet$Plain$Response(params?: V4CustomersMeOffersGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeOffersGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the offers applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOffersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersGet$Plain(params?: V4CustomersMeOffersGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeOffersGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /**
   * Gets the offers applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOffersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersGet$Json$Response(params?: V4CustomersMeOffersGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeOffersGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the offers applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOffersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersGet$Json(params?: V4CustomersMeOffersGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeOffersGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /**
   * Gets the offers applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOffersGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersGet$Xml$Response(params?: V4CustomersMeOffersGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeOffersGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the offers applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOffersGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersGet$Xml(params?: V4CustomersMeOffersGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeOffersGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeOffersOfferIdPatch()` */
  static readonly V4CustomersMeOffersOfferIdPatchPath = '/v4/customers/me/offers/{offerId}';

  /**
   * Saves the read status for offer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOffersOfferIdPatch$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersOfferIdPatch$Plain$Response(params: V4CustomersMeOffersOfferIdPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeOffersOfferIdPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for offer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOffersOfferIdPatch$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersOfferIdPatch$Plain(params: V4CustomersMeOffersOfferIdPatch$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeOffersOfferIdPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Saves the read status for offer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOffersOfferIdPatch$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersOfferIdPatch$Json$Response(params: V4CustomersMeOffersOfferIdPatch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeOffersOfferIdPatch$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for offer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOffersOfferIdPatch$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersOfferIdPatch$Json(params: V4CustomersMeOffersOfferIdPatch$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeOffersOfferIdPatch$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Saves the read status for offer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOffersOfferIdPatch$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersOfferIdPatch$Xml$Response(params: V4CustomersMeOffersOfferIdPatch$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeOffersOfferIdPatch$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for offer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOffersOfferIdPatch$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOffersOfferIdPatch$Xml(params: V4CustomersMeOffersOfferIdPatch$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeOffersOfferIdPatch$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeEnquiryPost()` */
  static readonly V4CustomersMeEnquiryPostPath = '/v4/customers/me/enquiry';

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeEnquiryPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeEnquiryPost$Json$Plain$Response(params?: V4CustomersMeEnquiryPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeEnquiryPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeEnquiryPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeEnquiryPost$Json$Plain(params?: V4CustomersMeEnquiryPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeEnquiryPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeEnquiryPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeEnquiryPost$Json$Json$Response(params?: V4CustomersMeEnquiryPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeEnquiryPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeEnquiryPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeEnquiryPost$Json$Json(params?: V4CustomersMeEnquiryPost$Json$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeEnquiryPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeEnquiryPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeEnquiryPost$Json$Xml$Response(params?: V4CustomersMeEnquiryPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeEnquiryPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeEnquiryPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeEnquiryPost$Json$Xml(params?: V4CustomersMeEnquiryPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeEnquiryPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeEnquiryPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeEnquiryPost$Xml$Plain$Response(params?: V4CustomersMeEnquiryPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeEnquiryPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeEnquiryPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeEnquiryPost$Xml$Plain(params?: V4CustomersMeEnquiryPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeEnquiryPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeEnquiryPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeEnquiryPost$Xml$Json$Response(params?: V4CustomersMeEnquiryPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeEnquiryPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeEnquiryPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeEnquiryPost$Xml$Json(params?: V4CustomersMeEnquiryPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeEnquiryPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeEnquiryPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeEnquiryPost$Xml$Xml$Response(params?: V4CustomersMeEnquiryPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeEnquiryPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeEnquiryPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeEnquiryPost$Xml$Xml(params?: V4CustomersMeEnquiryPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeEnquiryPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeNotificationsGet()` */
  static readonly V4CustomersMeNotificationsGetPath = '/v4/customers/me/notifications';

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsGet$Plain$Response(params?: V4CustomersMeNotificationsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeNotificationsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsGet$Plain(params?: V4CustomersMeNotificationsGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeNotificationsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsGet$Json$Response(params?: V4CustomersMeNotificationsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeNotificationsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsGet$Json(params?: V4CustomersMeNotificationsGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeNotificationsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsGet$Xml$Response(params?: V4CustomersMeNotificationsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeNotificationsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsGet$Xml(params?: V4CustomersMeNotificationsGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeNotificationsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeNotificationsPatch()` */
  static readonly V4CustomersMeNotificationsPatchPath = '/v4/customers/me/notifications';

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsPatch$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsPatch$Plain$Response(params?: V4CustomersMeNotificationsPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeNotificationsPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsPatch$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsPatch$Plain(params?: V4CustomersMeNotificationsPatch$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeNotificationsPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsPatch$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsPatch$Json$Response(params?: V4CustomersMeNotificationsPatch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeNotificationsPatch$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsPatch$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsPatch$Json(params?: V4CustomersMeNotificationsPatch$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeNotificationsPatch$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsPatch$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsPatch$Xml$Response(params?: V4CustomersMeNotificationsPatch$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeNotificationsPatch$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsPatch$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsPatch$Xml(params?: V4CustomersMeNotificationsPatch$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeNotificationsPatch$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeNotificationsNotificationIdGet()` */
  static readonly V4CustomersMeNotificationsNotificationIdGetPath = '/v4/customers/me/notifications/{notificationId}';

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsNotificationIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdGet$Plain$Response(params: V4CustomersMeNotificationsNotificationIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeNotificationsNotificationIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsNotificationIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdGet$Plain(params: V4CustomersMeNotificationsNotificationIdGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeNotificationsNotificationIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsNotificationIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdGet$Json$Response(params: V4CustomersMeNotificationsNotificationIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeNotificationsNotificationIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsNotificationIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdGet$Json(params: V4CustomersMeNotificationsNotificationIdGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeNotificationsNotificationIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsNotificationIdGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdGet$Xml$Response(params: V4CustomersMeNotificationsNotificationIdGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeNotificationsNotificationIdGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsNotificationIdGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdGet$Xml(params: V4CustomersMeNotificationsNotificationIdGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeNotificationsNotificationIdGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeNotificationsNotificationIdDelete()` */
  static readonly V4CustomersMeNotificationsNotificationIdDeletePath = '/v4/customers/me/notifications/{notificationId}';

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsNotificationIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdDelete$Plain$Response(params: V4CustomersMeNotificationsNotificationIdDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeNotificationsNotificationIdDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsNotificationIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdDelete$Plain(params: V4CustomersMeNotificationsNotificationIdDelete$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeNotificationsNotificationIdDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsNotificationIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdDelete$Json$Response(params: V4CustomersMeNotificationsNotificationIdDelete$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeNotificationsNotificationIdDelete$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsNotificationIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdDelete$Json(params: V4CustomersMeNotificationsNotificationIdDelete$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeNotificationsNotificationIdDelete$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsNotificationIdDelete$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdDelete$Xml$Response(params: V4CustomersMeNotificationsNotificationIdDelete$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeNotificationsNotificationIdDelete$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsNotificationIdDelete$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdDelete$Xml(params: V4CustomersMeNotificationsNotificationIdDelete$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeNotificationsNotificationIdDelete$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeNotificationsUnreadGet()` */
  static readonly V4CustomersMeNotificationsUnreadGetPath = '/v4/customers/me/notifications/unread';

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsUnreadGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsUnreadGet$Plain$Response(params?: V4CustomersMeNotificationsUnreadGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeNotificationsUnreadGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsUnreadGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsUnreadGet$Plain(params?: V4CustomersMeNotificationsUnreadGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeNotificationsUnreadGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsUnreadGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsUnreadGet$Json$Response(params?: V4CustomersMeNotificationsUnreadGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeNotificationsUnreadGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsUnreadGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsUnreadGet$Json(params?: V4CustomersMeNotificationsUnreadGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeNotificationsUnreadGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsUnreadGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsUnreadGet$Xml$Response(params?: V4CustomersMeNotificationsUnreadGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
    return v4CustomersMeNotificationsUnreadGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsUnreadGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsUnreadGet$Xml(params?: V4CustomersMeNotificationsUnreadGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOffersResponse> {
    return this.v4CustomersMeNotificationsUnreadGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOffersResponse>): ModelsCustomerCustomerOffersResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeNotificationsNotificationIdReadStatusPatch()` */
  static readonly V4CustomersMeNotificationsNotificationIdReadStatusPatchPath = '/v4/customers/me/notifications/{notificationId}/{readStatus}';

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsNotificationIdReadStatusPatch$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Response(params: V4CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeNotificationsNotificationIdReadStatusPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdReadStatusPatch$Plain(params: V4CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsNotificationIdReadStatusPatch$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Response(params: V4CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeNotificationsNotificationIdReadStatusPatch$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdReadStatusPatch$Json(params: V4CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeNotificationsNotificationIdReadStatusPatch$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Response(params: V4CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
    return v4CustomersMeNotificationsNotificationIdReadStatusPatch$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeNotificationsNotificationIdReadStatusPatch$Xml(params: V4CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiryResponse> {
    return this.v4CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>): ModelsCustomerCustomerEnquiryResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeOnlinePaymentsGet()` */
  static readonly V4CustomersMeOnlinePaymentsGetPath = '/v4/customers/me/online-payments';

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsGet$Plain$Response(params?: V4CustomersMeOnlinePaymentsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>> {
    return v4CustomersMeOnlinePaymentsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsGet$Plain(params?: V4CustomersMeOnlinePaymentsGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentsResponse> {
    return this.v4CustomersMeOnlinePaymentsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>): ModelsCustomerCustomerOnlinePaymentsResponse => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsGet$Json$Response(params?: V4CustomersMeOnlinePaymentsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>> {
    return v4CustomersMeOnlinePaymentsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsGet$Json(params?: V4CustomersMeOnlinePaymentsGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentsResponse> {
    return this.v4CustomersMeOnlinePaymentsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>): ModelsCustomerCustomerOnlinePaymentsResponse => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsGet$Xml$Response(params?: V4CustomersMeOnlinePaymentsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>> {
    return v4CustomersMeOnlinePaymentsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsGet$Xml(params?: V4CustomersMeOnlinePaymentsGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentsResponse> {
    return this.v4CustomersMeOnlinePaymentsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>): ModelsCustomerCustomerOnlinePaymentsResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeOnlinePaymentsPost()` */
  static readonly V4CustomersMeOnlinePaymentsPostPath = '/v4/customers/me/online-payments';

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeOnlinePaymentsPost$Json$Plain$Response(params?: V4CustomersMeOnlinePaymentsPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v4CustomersMeOnlinePaymentsPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeOnlinePaymentsPost$Json$Plain(params?: V4CustomersMeOnlinePaymentsPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v4CustomersMeOnlinePaymentsPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeOnlinePaymentsPost$Json$Json$Response(params?: V4CustomersMeOnlinePaymentsPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v4CustomersMeOnlinePaymentsPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeOnlinePaymentsPost$Json$Json(params?: V4CustomersMeOnlinePaymentsPost$Json$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v4CustomersMeOnlinePaymentsPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeOnlinePaymentsPost$Json$Xml$Response(params?: V4CustomersMeOnlinePaymentsPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v4CustomersMeOnlinePaymentsPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersMeOnlinePaymentsPost$Json$Xml(params?: V4CustomersMeOnlinePaymentsPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v4CustomersMeOnlinePaymentsPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeOnlinePaymentsPost$Xml$Plain$Response(params?: V4CustomersMeOnlinePaymentsPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v4CustomersMeOnlinePaymentsPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeOnlinePaymentsPost$Xml$Plain(params?: V4CustomersMeOnlinePaymentsPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v4CustomersMeOnlinePaymentsPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeOnlinePaymentsPost$Xml$Json$Response(params?: V4CustomersMeOnlinePaymentsPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v4CustomersMeOnlinePaymentsPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeOnlinePaymentsPost$Xml$Json(params?: V4CustomersMeOnlinePaymentsPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v4CustomersMeOnlinePaymentsPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeOnlinePaymentsPost$Xml$Xml$Response(params?: V4CustomersMeOnlinePaymentsPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v4CustomersMeOnlinePaymentsPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersMeOnlinePaymentsPost$Xml$Xml(params?: V4CustomersMeOnlinePaymentsPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v4CustomersMeOnlinePaymentsPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeOnlinePaymentsIdGet()` */
  static readonly V4CustomersMeOnlinePaymentsIdGetPath = '/v4/customers/me/online-payments/{id}';

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdGet$Plain$Response(params: V4CustomersMeOnlinePaymentsIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v4CustomersMeOnlinePaymentsIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdGet$Plain(params: V4CustomersMeOnlinePaymentsIdGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v4CustomersMeOnlinePaymentsIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdGet$Json$Response(params: V4CustomersMeOnlinePaymentsIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v4CustomersMeOnlinePaymentsIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdGet$Json(params: V4CustomersMeOnlinePaymentsIdGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v4CustomersMeOnlinePaymentsIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsIdGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdGet$Xml$Response(params: V4CustomersMeOnlinePaymentsIdGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v4CustomersMeOnlinePaymentsIdGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsIdGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdGet$Xml(params: V4CustomersMeOnlinePaymentsIdGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v4CustomersMeOnlinePaymentsIdGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeOnlinePaymentsIdStatusGet()` */
  static readonly V4CustomersMeOnlinePaymentsIdStatusGetPath = '/v4/customers/me/online-payments/{id}/status';

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsIdStatusGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdStatusGet$Plain$Response(params: V4CustomersMeOnlinePaymentsIdStatusGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>> {
    return v4CustomersMeOnlinePaymentsIdStatusGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsIdStatusGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdStatusGet$Plain(params: V4CustomersMeOnlinePaymentsIdStatusGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum> {
    return this.v4CustomersMeOnlinePaymentsIdStatusGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>): ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsIdStatusGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdStatusGet$Json$Response(params: V4CustomersMeOnlinePaymentsIdStatusGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>> {
    return v4CustomersMeOnlinePaymentsIdStatusGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsIdStatusGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdStatusGet$Json(params: V4CustomersMeOnlinePaymentsIdStatusGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum> {
    return this.v4CustomersMeOnlinePaymentsIdStatusGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>): ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentsIdStatusGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdStatusGet$Xml$Response(params: V4CustomersMeOnlinePaymentsIdStatusGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>> {
    return v4CustomersMeOnlinePaymentsIdStatusGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentsIdStatusGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentsIdStatusGet$Xml(params: V4CustomersMeOnlinePaymentsIdStatusGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum> {
    return this.v4CustomersMeOnlinePaymentsIdStatusGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>): ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum => r.body)
    );
  }

  /** Path part for operation `v4CustomersMeOnlinePaymentTypesGet()` */
  static readonly V4CustomersMeOnlinePaymentTypesGetPath = '/v4/customers/me/online-payment-types';

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentTypesGet$Plain$Response(params?: V4CustomersMeOnlinePaymentTypesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>> {
    return v4CustomersMeOnlinePaymentTypesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentTypesGet$Plain(params?: V4CustomersMeOnlinePaymentTypesGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentTypesResponse> {
    return this.v4CustomersMeOnlinePaymentTypesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>): ModelsCustomerCustomerOnlinePaymentTypesResponse => r.body)
    );
  }

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentTypesGet$Json$Response(params?: V4CustomersMeOnlinePaymentTypesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>> {
    return v4CustomersMeOnlinePaymentTypesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentTypesGet$Json(params?: V4CustomersMeOnlinePaymentTypesGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentTypesResponse> {
    return this.v4CustomersMeOnlinePaymentTypesGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>): ModelsCustomerCustomerOnlinePaymentTypesResponse => r.body)
    );
  }

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersMeOnlinePaymentTypesGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentTypesGet$Xml$Response(params?: V4CustomersMeOnlinePaymentTypesGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>> {
    return v4CustomersMeOnlinePaymentTypesGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersMeOnlinePaymentTypesGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CustomersMeOnlinePaymentTypesGet$Xml(params?: V4CustomersMeOnlinePaymentTypesGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentTypesResponse> {
    return this.v4CustomersMeOnlinePaymentTypesGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>): ModelsCustomerCustomerOnlinePaymentTypesResponse => r.body)
    );
  }

}
